import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class AutoArea extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.car_city} dangerouslySetInnerHTML={{ __html: content }} />;
    }
}

export default errorBoundary(AutoArea);
